// extracted by mini-css-extract-plugin
export default {"chart_wrap":"GenderGraph_chart_wrap__Sz6oV","chart_header":"GenderGraph_chart_header__jo7R4","label":"GenderGraph_label__d1YtI","chart_footer":"GenderGraph_chart_footer__SY2ei"};